import React, { useState, useEffect, useRef } from 'react';

// 54 Farben: 9 Spalten (Regenbogen) × 6 Reihen (hell→dunkel)
const FARBEN = [
  // Zeile 1 – hell
  '#FC8181', '#F6AD55', '#F6E05E', '#68D391', '#4FD1C5', '#63B3ED', '#7F9CF5', '#B794F4', '#F687B3',
  // Zeile 2
  '#E53E3E', '#DD6B20', '#D69E2E', '#38A169', '#319795', '#3182CE', '#5A67D8', '#805AD5', '#D53F8C',
  // Zeile 3
  '#C53030', '#C05621', '#B7791F', '#276749', '#234E52', '#2B6CB0', '#434190', '#553C9A', '#97266D',
  // Zeile 4
  '#9B2335', '#9C4221', '#975A16', '#1C4532', '#1D4044', '#1A365D', '#3C366B', '#44337A', '#702459',
  // Zeile 5 – neutral/dunkel
  '#718096', '#4A5568', '#2D3748', '#1A202C', '#744210', '#22543D', '#065666', '#2A4365', '#322659',
  // Zeile 6 – sehr dunkel
  '#A0AEC0', '#CBD5E0', '#E2E8F0', '#F7FAFC', '#FEFCE8', '#F0FFF4', '#E6FFFA', '#EBF8FF', '#FAF5FF',
];

const FarbAuswahl = ({ ausgewaehlt, onWaehlen }) => {
  const [offen, setOffen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOffen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const waehlen = (farbe) => {
    onWaehlen(farbe);
    setOffen(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      {/* Button */}
      <button onClick={() => setOffen(!offen)} style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        padding: '6px 12px', fontSize: '13px', border: '1px solid #e8e8e8',
        borderRadius: '8px', backgroundColor: '#ffffff', cursor: 'pointer', color: '#1a1a1a'
      }}>
        {ausgewaehlt ? (
          <span style={{
            width: '14px', height: '14px', borderRadius: '50%',
            backgroundColor: ausgewaehlt, display: 'inline-block', flexShrink: 0,
            border: '1px solid rgba(0,0,0,0.1)'
          }} />
        ) : (
          <span style={{
            width: '14px', height: '14px', borderRadius: '50%',
            border: '1px dashed #c4c4c4', display: 'inline-block', flexShrink: 0
          }} />
        )}
        <span>{ausgewaehlt ? 'Farbe ändern' : 'Farbe wählen'}</span>
        <span style={{ color: '#c4c4c4', fontSize: '10px' }}>▼</span>
      </button>

      {/* Dropdown */}
      {offen && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 200,
          backgroundColor: '#ffffff', border: '1px solid #e8e8e8', borderRadius: '10px',
          padding: '12px', boxShadow: '0 8px 28px rgba(0,0,0,0.12)', minWidth: '220px'
        }}>
          {/* Keine Farbe */}
          <div style={{ marginBottom: '10px' }}>
            <div onClick={() => waehlen(null)} style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px',
              color: '#6b6b6b', border: '1px solid #e8e8e8',
              backgroundColor: !ausgewaehlt ? '#f0f0ee' : 'transparent'
            }}>
              <span style={{ width: '12px', height: '12px', borderRadius: '50%', border: '1px dashed #c4c4c4', display: 'inline-block' }} />
              Keine Farbe
            </div>
          </div>

          {/* Farbpalette 9×6 */}
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(9, 20px)', gap: '4px'
          }}>
            {FARBEN.map(farbe => (
              <div
                key={farbe}
                onClick={() => waehlen(farbe)}
                title={farbe}
                style={{
                  width: '20px', height: '20px', borderRadius: '4px',
                  backgroundColor: farbe, cursor: 'pointer',
                  border: ausgewaehlt === farbe ? '2px solid #1a1a1a' : '1px solid rgba(0,0,0,0.08)',
                  boxSizing: 'border-box',
                  transform: ausgewaehlt === farbe ? 'scale(1.2)' : 'scale(1)',
                  transition: 'transform 0.1s'
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FarbAuswahl;
export { FARBEN };